import React, { useState } from 'react';
import { Activity, Search, Users, BookOpen, CreditCard, Shield,  } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Badge } from '@/components/ui/badge';

const ACTIVITY_LOG = [
  { id: 1, type: 'enroll', user: 'Aisha Patel', action: 'Enrolled in Generative AI', ip: '103.21.x.x', time: '2026-04-03 14:22', region: 'Mumbai' },
  { id: 2, type: 'payment', user: 'Marcus Johnson', action: 'Payment ₹41,999 for Full Stack Dev', ip: '192.168.x.x', time: '2026-04-03 13:55', region: 'Delhi' },
  { id: 3, type: 'auth', user: 'Admin', action: 'Admin login from new device', ip: '10.0.x.x', time: '2026-04-03 12:00', region: 'Bangalore' },
  { id: 4, type: 'course', user: 'Vikram Singh', action: 'Submitted new course for approval', ip: '117.96.x.x', time: '2026-04-03 11:30', region: 'Hyderabad' },
  { id: 5, type: 'enroll', user: 'Priya Nair', action: 'Enrolled in Python Programming', ip: '49.36.x.x', time: '2026-04-03 10:15', region: 'Chennai' },
  { id: 6, type: 'payment', user: 'Sophie Martinez', action: 'Refund ₹34,999 processed', ip: '182.71.x.x', time: '2026-04-03 09:45', region: 'Pune' },
  { id: 7, type: 'auth', user: 'Rohan D.', action: 'Password reset requested', ip: '103.55.x.x', time: '2026-04-03 09:10', region: 'Kolkata' },
  { id: 8, type: 'course', user: 'Admin', action: 'Approved: Agentic AI course', ip: '10.0.x.x', time: '2026-04-03 08:30', region: 'Bangalore' },
  { id: 9, type: 'enroll', user: 'Kavya L.', action: 'Enrolled in Cyber Security (VAPT)', ip: '59.88.x.x', time: '2026-04-02 23:10', region: 'Ahmedabad' },
  { id: 10, type: 'payment', user: 'Arjun T.', action: 'Payment ₹46,999 for AIML', ip: '115.112.x.x', time: '2026-04-02 22:45', region: 'Jaipur' },
];

const TYPE_CONFIG = {
  enroll: { icon: Users, color: 'bg-blue-100 text-blue-600', label: 'Enrollment' },
  payment: { icon: CreditCard, color: 'bg-green-100 text-green-600', label: 'Payment' },
  auth: { icon: Shield, color: 'bg-red-100 text-red-600', label: 'Auth' },
  course: { icon: BookOpen, color: 'bg-purple-100 text-purple-600', label: 'Course' },
};

export default function AdminActivityLog() {
  const [search, setSearch] = useState('');
  const [typeFilter, setTypeFilter] = useState('all');

  const filtered = ACTIVITY_LOG.filter(a => {
    const matchSearch = a.user.toLowerCase().includes(search.toLowerCase()) || a.action.toLowerCase().includes(search.toLowerCase());
    const matchType = typeFilter === 'all' || a.type === typeFilter;
    return matchSearch && matchType;
  });

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="font-heading text-xl font-bold">Platform Activity</h2>
          <p className="text-sm text-muted-foreground">Real-time log of all platform events</p>
        </div>
        <div className="flex items-center gap-1.5">
          <div className="w-2 h-2 rounded-full bg-green-500 animate-pulse" />
          <span className="text-xs text-muted-foreground">Live</span>
        </div>
      </div>

      <div className="flex gap-3 flex-wrap">
        <div className="relative flex-1 min-w-[200px]">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
          <Input value={search} onChange={e => setSearch(e.target.value)} placeholder="Search activity..." className="pl-9" />
        </div>
        <div className="flex gap-1.5">
          {['all', 'enroll', 'payment', 'auth', 'course'].map(t => (
            <button key={t} onClick={() => setTypeFilter(t)}
              className={`text-xs px-3 py-1.5 rounded-full font-medium transition-all ${typeFilter === t ? 'bg-primary text-primary-foreground' : 'bg-muted text-muted-foreground'}`}>
              {t === 'all' ? 'All' : TYPE_CONFIG[t]?.label || t}
            </button>
          ))}
        </div>
      </div>

      <div className="bg-card rounded-xl border overflow-hidden">
        {filtered.map((log, i) => {
          const cfg = TYPE_CONFIG[log.type];
          const Icon = cfg?.icon || Activity;
          return (
            <div key={log.id} className={`flex items-start gap-3 p-4 ${i < filtered.length - 1 ? 'border-b' : ''} hover:bg-muted/20 transition-colors`}>
              <div className={`w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0 ${cfg?.color || 'bg-muted text-muted-foreground'}`}>
                <Icon className="w-4 h-4" />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <span className="font-medium text-sm">{log.user}</span>
                  <Badge className={`text-xs border-0 ${cfg?.color || 'bg-muted'}`}>{cfg?.label}</Badge>
                </div>
                <p className="text-xs text-muted-foreground mt-0.5">{log.action}</p>
              </div>
              <div className="text-right flex-shrink-0">
                <p className="text-xs text-muted-foreground">{log.time.split(' ')[1]}</p>
                <p className="text-xs text-muted-foreground/60">{log.region}</p>
              </div>
            </div>
          );
        })}
        {filtered.length === 0 && (
          <div className="text-center py-10 text-muted-foreground">
            <Activity className="w-8 h-8 mx-auto mb-2 opacity-30" />
            <p className="text-sm">No activity found</p>
          </div>
        )}
      </div>
    </div>
  );
}